import { useRecoilState } from 'recoil';

import { clinicalNote as clinicalNoteState } from 'components/state';

const useClinicalNoteState = ({ customCN, setCustomCN }) => {
  const [clinicalNote, setClinicalNote] = useRecoilState(clinicalNoteState);

  const hasCustom = customCN !== undefined;
  const hasSetter = setCustomCN !== undefined;

  if (hasCustom && hasSetter) return [customCN, setCustomCN];

  if (hasCustom || hasSetter) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(
        'Invalid usage of useClinicalNoteState: both `customCN` and `setCustomCN` must be provided together.'
      );
    } else {
      console.warn(
        'useClinicalNoteState: both `customCN` and `setCustomCN` should be provided together.'
      );
    }
  }

  return [clinicalNote, setClinicalNote];
};

export default useClinicalNoteState;
